export const getCategoriesRoute = '/category/get';
export const createCategoryRoute = '/category/create';
export const updateCategoryRoute = '/category/update';
export const deleteCategoryRoute = '/category/delete';
